import React, {
  FunctionComponent,
  useEffect,
  useState
} from "react";
import styles from "./ToggleButton.module.css";
import { connect, useDispatch } from "react-redux";
import { updateTheme } from "../../Redux/actions";

type props = {
  checked: any;
  onChange: any;
  id: any;
  customStyles?: any;
};

const ToggleButton: FunctionComponent<props> = ({
  checked,
  onChange,
  id,
  customStyles,
}) => {
  return (
    <div>
      <input type="checkbox" checked={checked}  onChange={onChange} className={styles.checkbox} id={id} />
      <label htmlFor={id} className={styles.label} style={{...customStyles}}>
        {/* <i className="fas fa-moon" style={{color:"white"}}></i>
    <i className='fas fa-sun' style={{color:"yellow"}}></i> */}
        <div className={styles.ball}></div>
      </label>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    // snackbarData: state.snackbar,
    // theme:state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ToggleButton);
